import api from "@/api";
import router from "@/router";

export default {
  state: {
    reports: [],
  },
  getters: {
    reports: (state) => state.reports,
  },
  mutations: {
    setReports: (state, data) => {
      state.reports = data;
    },
  },
  actions: {
    getReports: async ({ commit }, request = {}) => {
      try {
        const normalizedRequest =
          request && typeof request === "object"
            ? request
            : { team_id: request };
        const query = normalizedRequest.query || router.currentRoute?.value?.query || {};
        const team_id = normalizedRequest.team_id || normalizedRequest.teamId || null;
        const {
          userId,
          teamId,
          paidStatus,
          month,
          year,
          ahv,
          bvg,
          bvgValue,
          startDate,
          endDate,
        } = query;

        let requestPayload = {
          paid_status: paidStatus === "true",
          user_id: userId,
          month: month,
          year: year,
          ahv: ahv === "true",
          bvg: bvg === "true",
          team_id: team_id || teamId,
          bvg_value: bvg === "true" ? bvgValue : 0,
        };

        if (startDate && endDate) {
          requestPayload = {
            ...requestPayload,
            start_date: startDate,
            end_date: endDate,
          };
        }

        const {
          data: { data },
        } = await api({ requiresAuth: true }).post("/v1/reports", {
          ...requestPayload,
        });

        commit(
          "setReports",
          data.map((period) => {
            for (let p in period) {
              return { ...period[p], period: p };
            }
          })
        );
      } catch (err) {
        console.error(err);
      }
    },

    getPaymentReport: async ({ commit }, request = {}) => {
      try {
        const normalizedRequest =
          request && typeof request === "object"
            ? request
            : {};
        const query = normalizedRequest.query || router.currentRoute?.value?.query || {};
        const {
          userId,
          paidStatus,
          month,
          year,
          ahv,
          bvg,
          bvgValue,
          startDate,
          endDate,
        } = query;

        let requestPayload = {
          paid_status: paidStatus === "true",
          user_id: userId,
          month: month,
          year: year,
          ahv: ahv === "true",
          bvg: bvg === "true",
          bvg_value: bvg === "true" ? bvgValue : 0,
        };

        if (startDate && endDate) {
          requestPayload = {
            ...requestPayload,
            start_date: startDate,
            end_date: endDate,
          };
        }

        const {
          data: { data },
        } = await api({ requiresAuth: true }).post("/v1/payment-report", {
          ...requestPayload,
        });

        commit(
          "setReports",
          data.map((period) => {
            for (let p in period) {
              return { ...period[p], period: p };
            }
          })
        );
      } catch (err) {
        console.error(err);
      }
    },

    makePayment: (_, data) =>
      api({ requiresAuth: true }).patch("/v1/reports/payments", {
        ...data,
      }),
  },
};
